import { BaseExercise } from "@domain/exercise/exercise";

export interface Equipment {
	name: string;
}

export function getAllEquipmentNamesFromExercises(exercises: BaseExercise[] = []): string[] {
    const equipmentSet = new Set<string>();
    exercises.forEach(ex => {
        ex.requiredEquipments.forEach((eq: Equipment) => {
            if (eq.name) equipmentSet.add(eq.name);
        });
        ex.optionalEquipments.forEach((eq: Equipment) => {
            if (eq.name) equipmentSet.add(eq.name);
        });
    });
    return Array.from(equipmentSet);
}
